/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_ContactInputs */

const fr_legal_contact = /** @type {(inputs: Legal_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact :`)
};

const en_legal_contact = /** @type {(inputs: Legal_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact:`)
};

/**
* | output |
* | --- |
* | "Contact:" |
*
* @param {Legal_ContactInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_contact = /** @type {((inputs?: Legal_ContactInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_ContactInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_contact(inputs)
	return en_legal_contact(inputs)
});